<script>
import { mapGetters } from 'vuex';
import ProgressStatus from '../components/ProgressStatus.vue';
import QuizOptionList from '../components/QuizOptionList.vue';
import InfoButton from 'ne01-common/src/components/InfoButton';
import { Howl } from 'howler';

export default {
  name: 'QuizPage',
  components: {
    ProgressStatus,
    QuizOptionList,
    InfoButton,
  },
  data: () => {
    return {
      showNextButton: false,
    }
  },
  mounted() {
    document.addEventListener('click', this.countClick);
    this.startQuiz();
  },
  methods: {
    startQuiz() {
      this.$store.dispatch('startStation');
    },
    nextLevel() {
      if (this.currentLevelIndex + 1 < this.totalLevels) {
        this.showNextButton = false;
        this.$store.dispatch('nextLevel');
      } else
        this.exitStation();
    },
    exitStation() {
      this.$store.dispatch('exitStation');
    },
    countClick() {
      this.$store.dispatch('clickCount');
    },
    playLevelVoiceover() {
      if (this.currentLevelVoiceover) {
        const audio = new Howl({
          src: [this.currentLevelVoiceover],
          autoplay: true,
        });
      }
    },
    onInfoOverlayStateChange(state) {
      if (state === 'open')
        this.$store.dispatch('setGlobalPlayState', false);
      else if (state === 'close')
        this.$store.dispatch('setGlobalPlayState', true);
    },
  },
  computed: {
    ...mapGetters({
      quizInstruction: 'getQuizinstruction',
      currentLevel: 'getCurrentLevel',
      currentLevelIndex: 'getCurrentLevelIndex',
      currentLevelOptions: 'getCurrentLevelOptions',
      currentLevelVoiceover: 'getCurrentLevelVoiceover',
      totalLevels: 'getTotalLevels',
      levelStats: 'getCurrentLevelStatistics',
      levelInfoButton: 'getCurrentLevelInfoPageId',
      isLevelEnd: 'getIsLevelEnd',
    }),
    showExpertLevelButton() {
      return (this.totalLevels - (this.currentLevelIndex + 1) === 1);
    },
  },
  watch: {
    isLevelEnd(newValue, oldValue) {
      if (newValue !== oldValue && newValue) {
        setTimeout(() => {
          this.playLevelVoiceover();
          this.showNextButton = true;
        }, 1500);
      }
        
    },
  },
  beforeDestroy() {
    document.removeEventListener('click', this.countClick);
  }
}
</script>

<template>
  <div class="quiz">
    <div class="quiz__content">
      <p class="quiz__instruction">{{quizInstruction}}</p>
      <progress-status class="quiz__progress" v-bind:total="totalLevels - 1" v-bind:current="currentLevelIndex + 1" />
      <quiz-option-list v-bind:options="currentLevelOptions" v-bind:currentLevelIndex="currentLevelIndex" v-if="currentLevelOptions" v-bind:key="currentLevelIndex" />
    </div>

    <div class="quiz__actions">
      <transition name="info-transition">
        <info-button class="quiz__info-button" v-bind:key="levelInfoButton" v-bind:id="levelInfoButton" v-on:stateChanged="onInfoOverlayStateChange" v-if="levelInfoButton" />
      </transition>
      <transition name="button-transition">
        <button 
          v-if="showNextButton && !showExpertLevelButton"
          class="quiz__next-level common-button" 
          v-on:click="nextLevel()">
            {{$t('quiz.next')}}
        </button>
      </transition>
      <transition name="button-transition">
        <button 
          v-if="showNextButton && showExpertLevelButton"
          class="quiz__next-level common-button" 
          v-on:click="exitStation()">
            {{$t('quiz.exitStation')}}
        </button>
      </transition>
      <transition name="button-transition">
        <button 
          v-if="showNextButton && showExpertLevelButton"
          class="quiz__expert-button common-button common-button--secondary"
          v-on:click="nextLevel()">
            {{$t('quiz.expertModeButton')}}
        </button>
      </transition>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '../assets/styles/variables';
@import '../assets/styles/common';

.quiz {
  font-family: var(--font-family-secondary);
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.quiz__instruction {
  font-size: 1.75rem;
  line-height: 1.34;
  max-width: 36rem;
  margin: 3rem 0 3rem;
}
.quiz__level-end-message {
  text-align: center;
  font-size: 1.3em;
}
.quiz__progress {
  width: 100%;
  margin-bottom: 2rem;
}
.quiz__actions {
  min-height: 17.2rem;
}
.button-transition-enter-active {
  transform-origin: 50% 300%;
  transition: 100ms opacity linear 250ms, 666ms transform cubic-bezier(.8,.3,.25,1.66) 0;
}
.button-transition-enter {
  opacity: 0;
  transform: translate3d(0, 0, 20rem) rotateX(-80deg) skewY(-10deg);
}
.button-transition-leave-active {
  transition: 100ms opacity linear 0ms;
}
.button-transition-leave-to {
  opacity: 0;
}
.quiz__info-button {
  margin: 4rem 0;
}
.info-transition-enter-active {
  transform-origin: 50% 300%;
  transition: 100ms opacity linear 300ms, 400ms transform cubic-bezier(.8,.3,.25,1.66) 100ms;
}
.info-transition-enter {
  opacity: 0;
  transform: translateY(4rem);
}
.info-transition-leave-active {
  transition: 100ms opacity linear 0ms;
}
.info-transition-leave-to {
  opacity: 0;
}
.quiz__expert-button {
  margin-top: 1rem;
}
</style>
